import React, { useState } from 'react';

const IMAGE = `${process.env.PUBLIC_URL}/assets/images/warehouse/warehouse-doorway-wide.webp`;
const MOBILE_IMAGE = `${process.env.PUBLIC_URL}/assets/images/warehouse/warehouse-doorway-mobile.webp`;
const OPERATIONS_IMAGE = `${process.env.PUBLIC_URL}/assets/images/warehouse/warehouse-operations.webp`;
const SITE3S = process.env.REACT_APP_SITE3S === '1';

// Hero visual for the /site3 variant: the supplied Changi warehouse doorway
// scene extended to a wider warehouse view, with shading for readable copy.
const WarehouseVisual: React.FC = () => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className={`lp-wh${SITE3S ? ' lp-wh--site3s' : ''}`} aria-hidden="true">
      <picture>
        {!SITE3S && <source media="(max-width: 1023px)" srcSet={MOBILE_IMAGE} />}
        <img
          src={SITE3S ? OPERATIONS_IMAGE : IMAGE}
          alt=""
          className={`lp-wh-img ${loaded ? 'is-loaded' : ''}`}
          onLoad={() => setLoaded(true)}
          draggable={false}
        />
      </picture>
      <div className="lp-wh-shade" />
    </div>
  );
};

export default WarehouseVisual;
